'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _query = require('utilities/query');

var _categoryAutocomplete = require('./category-autocomplete.html');

var _categoryAutocomplete2 = _interopRequireDefault(_categoryAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _categoryAutocomplete2.default,
  bindings: {
    labelText: '@',
    searchDisplayProperty: '@',
    onItemSelected: '&'
  },
  controller: function () {
    function CategoryAutocomplete(EventEmitter, CategoryService) {
      'ngInject';

      _classCallCheck(this, CategoryAutocomplete);

      Object.assign(this, {
        EventEmitter: EventEmitter,
        CategoryService: CategoryService
      });
    }

    _createClass(CategoryAutocomplete, [{
      key: 'searchCategories',
      value: function searchCategories(name) {
        var query = _extends({}, this.CategoryService.getDefaultQuery(), {
          filter: (0, _odataFilterBuilder2.default)().and(function (x) {
            return x.contains('ProductCategoryName', name);
          })
        });

        return this.CategoryService.search(query).then(function (r) {
          return (0, _query.transformODataResponse)(r).Data;
        });
      }
    }, {
      key: 'selectedItemChanged',
      value: function selectedItemChanged(selectedItem) {
        this.onItemSelected(this.EventEmitter({
          selectedItem: selectedItem
        }));
      }
    }]);

    return CategoryAutocomplete;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/autocomplete/category/category-autocomplete.component.js